/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * UXDS namespace for developer-tools document version list/preview
 */
export const DocumentVersionsNamespace = {
  ProcessView: "process_view",
  FacilityMap: "facility_map",
} as const;
/**
 * UXDS namespace for developer-tools document version list/preview
 */
export type DocumentVersionsNamespace = ClosedEnum<
  typeof DocumentVersionsNamespace
>;

/** @internal */
export const DocumentVersionsNamespace$inboundSchema: z.ZodNativeEnum<
  typeof DocumentVersionsNamespace
> = z.nativeEnum(DocumentVersionsNamespace);
/** @internal */
export const DocumentVersionsNamespace$outboundSchema: z.ZodNativeEnum<
  typeof DocumentVersionsNamespace
> = DocumentVersionsNamespace$inboundSchema;
